
import _ from 'lodash';
import clip from '@/utils/clipboard'; // use clipboard directly
import { fetchCreationDetail } from '@/api/demand/creation';

/**
 * 接口返回data列表字段于vue字段不一致，字段转换
 * @param {*} data
 */
var transData2Treedata = function transData2Treedata(data, key) {
  var tData = _.cloneDeep(data);
  var subKey = '';
  subKey = key || 'sub_tags';
  var fnChangeKey = function fnChangeKey(data) {
    data.forEach(function (item, i) {
      data[i]['label'] = data[i]['name'];
      delete data[i]['name'];
      // 递归
      if (data[i][subKey] && data[i][subKey].length > 0) {
        data[i]['children'] = data[i][subKey];
        delete data[i][subKey];
        fnChangeKey(data[i].children);
      }
    });
  };
  fnChangeKey(tData);
  return tData;
  // const dataString = JSON.stringify(data).replace(/"name"/g, '"label"').replace(/"sub_tags"/g, '"children"')
  // return JSON.parse(dataString)
};

export default {
  props: {
    detail: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      loading: false,
      data: {}
    };
  },

  computed: {
    parseTagName: function parseTagName() {
      if (this.data && this.data.material_tag_names && this.data.material_tag_names.length) {
        var tagName = {};
        try {
          tagName = JSON.parse(this.data.material_tag_names);
        } catch (error) {
          console.warn('存在material_tag_names不是json字符串的数据');
        }
        return _.map(tagName, function (e) {
          return e;
        }).join();
      }
      return '';
    }
  },
  watch: {
    'detail.visible': function detailVisible(val) {
      if (val) {
        this.getDemandDetail();
      }
    }
  },
  methods: {
    getDemandDetail: function getDemandDetail() {
      var _this = this;

      this.loading = true;
      fetchCreationDetail({
        id: this.detail.id
      }).then(function (res) {
        _this.loading = false;
        _this.data = res.data.data.info;
        _this.data.tagsList = transData2Treedata(res.data.data.tags);
      }).catch(function () {
        _this.loading = false;
      });
    },
    handleCopy: function handleCopy(text, event) {
      clip(text, event);
    }
  }
};